import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { enableMapSet } from 'immer';
import './styles/mantine';
// Fonts: only the faces something renders (UI round 2, Lane G). Instrument Sans is the UI face at
// 400/500/600/700 (`fw` props) with an italic for markdown emphasis; Newsreader is the serif for
// titles at 400 (decision D-1, theme `headings`), 600 for markdown table heads, 700 for bold inside
// a serif heading, and 400 italic for emphasis inside one; Roboto Mono sets code at 400. Newsreader
// 300/500 and Roboto Mono 500 had no user. The first-paint faces (Instrument Sans 400/500, latin)
// are also preloaded from index.html: a browser fetches a face only once text needs it, which in an
// SPA is after the bundle has rendered, so without the preload they start last.
import '@fontsource/instrument-sans/400.css';
import '@fontsource/instrument-sans/500.css';
import '@fontsource/instrument-sans/600.css';
import '@fontsource/instrument-sans/700.css';
import '@fontsource/instrument-sans/400-italic.css';
import '@fontsource/newsreader/400.css';
import '@fontsource/newsreader/600.css';
import '@fontsource/newsreader/700.css';
import '@fontsource/newsreader/400-italic.css';
import '@fontsource/roboto-mono/400.css';
import { App } from './App';
import { installPreloadErrorReload } from './lib/preload-error';

// Before the first render, so a stale-deployment chunk failure in the very first lazy route is
// covered too (docs/code-splitting.md).
installPreloadErrorReload();

// Enable Immer MapSet plugin for Zustand stores that use Map/Set
enableMapSet();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
